import certficate1 from '../../assets/certficate1.jpeg'
import certficate2 from '../../assets/certficate2.jpeg'
import certificate3 from '../../assets/certficate3.jpeg'


export const certficateCarddata = [
    {
        Imgsrc: certficate1,
        title: "Responsive Web Design",
        text: "Earned Responsive Web Design certification from FreeCodeCamp, showcasing expertise in creating user-friendly and visually appealing websites that seamlessly adapt to various devices and screen sizes.",
        sources: "https://www.freecodecamp.org/certification/fcc08f66e30-4d6e-47e1-b460-8373725241ed/responsive-web-design"
    },

    {
        Imgsrc: certficate2,
        title: "javascript ",
        text: "Earned JavaScript certificate from FreeCodeCamp, demonstrating proficiency in building interactive and dynamic web applications, enhancing user experience through client-side scripting and event-driven programming.",
        sources: "https://www.freecodecamp.org/certification/fcc08f66e30-4d6e-47e1-b460-8373725241ed/javascript-algorithms-and-data-structures"
    },

    {
        Imgsrc: certificate3,
        title: "Front End Libraries",
        text: "Completed Front End Development Libraries certification on FreeCodeCamp, demonstrating proficiency in using powerful libraries like React and Redux to build dynamic and interactive web applications",
        sources: "https://www.freecodecamp.org/certification/fcc08f66e30-4d6e-47e1-b460-8373725241ed/front-end-development-libraries"
    }
];

